interface ITemplate {
  userAgent: IUserAgent;
  templateId: string;
  reviewStatus: string;
  videoPath: string;
  imagePath: string;
  filePath: string;
  firstFramePath: string;
  assetLevel: string;
  projectLevel: string;
  ratios: string;
  clips: string;
  duration: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  deletedAt: string;
  author: IAuthor;
  rejected: IReject;
  categories: ICategories[];
  category: [];
  translations: ITranslations[];
  metaLanguageCode: string;
  metaCountryCode: [];
  shares: IShares[];
  relation: IRelation;
  reviewer: string;
  scores: IScores;
  jiraTicket: string;
  recommended: boolean;
  gacha: boolean;
  extraDescription: IExtraDescription;
  kineInfo: IKineInfo;
  subscriberAtUpload: boolean;
  forbiddenWords: IForbiddenWords[];
}

interface IAuthor {
  sub: number;
  name: string;
  username: string;
  profileImage: string;
  isOfficial: boolean;
  status: string;
}

interface IReject {
  reason: string;
  fails: [];
}

interface ICategories {
  id: string;
}

interface ITranslations {
  description: string;
  language: string;
  languageName: string;
}

interface IShares {
  language: string;
  dynamicLink: string;
  default: boolean;
}

interface IRelation {
  parentId: string;
  projectId: string;
  parentTemplate: IParentTemplate;
}

interface IParentTemplate {
  id: string;
  imagePath: string;
  status: boolean;
}

interface IScores {
  mixability: number;
  reference: number;
  asset: number;
  entertainment: number;
}

interface IExtraDescription {
  language: string;
  languageName: string;
  description: string;
}

interface IUserAgent {
  appName: string;
  userAgent: string;
  appVersion: string;
  model: string;
  os: string;
  osVersion: string;
}

interface IKineInfo {
  existAudio: boolean;
}

interface IForbiddenWords {
  lenguage: string;
  keyword: string;
}

interface IKineInfo {
  complexity: IComplexity;
  existAudio: boolean;
  hash: string;
}

interface IComplexity {
  videoClipCount: number;
  imageClipCount: number;
  transitionCount: number;
  audioClipCount: number;
  layerVideoCount: number;
  layerImageCount: number;
  layerTextCount: number;
  layerHandwritingCount: number;
  layerAssetCount: number;
  mediaDependentAssetsCount: number;
}

export const initAutor: IAuthor = {
  sub: 0,
  name: "", // 사용자 nickname
  username: "", // 사용자 고유 이름
  profileImage: "",
  isOfficial: true,
  status: "",
};

export const initReject: IReject = {
  reason: "",
  fails: [],
};

export const initCategories: ICategories = {
  id: "",
};

export const initShares: IShares = {
  language: "",
  dynamicLink: "",
  default: true,
};

export const initTranslations: ITranslations = {
  description: "",
  language: "",
  languageName: "",
};

export const initParentTemplate: IParentTemplate = {
  id: "",
  imagePath: "",
  status: false,
};

export const initRelation: IRelation = {
  parentId: "",
  projectId: "",
  parentTemplate: initParentTemplate,
};

export const initScores: IScores = {
  mixability: 1,
  reference: 1,
  asset: 1,
  entertainment: 1,
};

export const initExtraDescription: IExtraDescription = {
  language: "en",
  languageName: "english",
  description: "",
};

export const initUserAgent: IUserAgent = {
  appName: "",
  userAgent: "",
  appVersion: "",
  model: "",
  os: "",
  osVersion: "",
};

export const initForbiddenWords: IForbiddenWords = {
  lenguage: "",
  keyword: "",
};

export const initComplexity: IComplexity = {
  videoClipCount: 0,
  imageClipCount: 0,
  transitionCount: 0,
  audioClipCount: 0,
  layerVideoCount: 0,
  layerImageCount: 0,
  layerTextCount: 0,
  layerHandwritingCount: 0,
  layerAssetCount: 0,
  mediaDependentAssetsCount: 0,
};

export const initKineInfo: IKineInfo = {
  existAudio: true,
  hash: "",
  complexity: initComplexity,
};

export const initTemplateDetail: ITemplate = {
  templateId: "",
  reviewStatus: "",
  videoPath: "",
  imagePath: "",
  filePath: "",
  firstFramePath: "",
  assetLevel: "",
  projectLevel: "",
  ratios: "",
  clips: "",
  duration: "",
  createdAt: "",
  updatedAt: "",
  publishedAt: "",
  deletedAt: "",
  author: initAutor,
  rejected: initReject,
  categories: [],
  category: [],
  translations: [],
  metaLanguageCode: "",
  metaCountryCode: [],
  shares: [],
  relation: initRelation,
  reviewer: "",
  scores: initScores,
  jiraTicket: "",
  recommended: false,
  gacha: false,
  extraDescription: initExtraDescription,
  userAgent: initUserAgent,
  kineInfo: initKineInfo,
  subscriberAtUpload: false,
  forbiddenWords: [],
};

export type { ITemplate, ICategories, IUserAgent };
